export default function (string, length) {
  if (!string) return null;
  if (string.length <= length) return string;
  return `${string.slice(0, length)}...`;
}
